import { ModelBase } from 'store/model-base';

export class CmsNowStepUpAuth extends ModelBase {
    public static storeName: string = 'cmsNowStepUpAuth';

    public error: NowStepUpAuthContent;
}
